export default __webpack_public_path__ + "assets/images/ISODATATransformTest-764db68c135ea639d0ebf8e89b85226e.png";